import { Link } from "react-router-dom";
import { cn } from "@/utils/cn";

interface SectionEmptyProps {
  icon: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionEmpty({
  icon,
  title,
  description,
  actionLabel,
  actionTo,
}: SectionEmptyProps) {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-8 text-center">
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-background-100 text-foreground-500">
        <i className={cn(icon, "text-xl")} aria-hidden="true" />
      </span>
      <p className="mt-3 text-sm font-label font-medium text-foreground-900">{title}</p>
      {description && <p className="mt-1 max-w-xs text-xs leading-relaxed text-foreground-500">{description}</p>}
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-foreground-200 bg-background-50 px-3.5 py-2 text-xs font-label font-medium text-foreground-900 transition-colors hover:bg-background-100 cursor-pointer"
        >
          <i className="ri-add-line text-base" aria-hidden="true" />
          {actionLabel}
        </Link>
      )}
    </div>
  );
}